export default __webpack_public_path__ + "static/media/File.200711ab.svg";